
import { initializeApp } from 'firebase/app';
import { environment } from './environments';

export const firebaseApp = initializeApp(environment[process.env.REACT_APP_FIREBASE_CONFIG]);